import fieldAliases from "./aliases";
import FormBuilder from "./components/FormBuilder.vue";
import ErrorList from "./components/errors/ErrorList.vue";
import InlineError from "./components/errors/InlineError.vue";

export {
	fieldAliases,
	FormBuilder,
	ErrorList,
	InlineError,
	FormBuilder as default
};
